import { Link } from 'react-router-dom'
import { Card } from '../components/ui/Card'

// NotFound — terminal 404 page. Renders inside the authenticated
// layout when the user is signed in (router decides), so the chrome
// stays consistent.
export function NotFound() {
  return (
    <Card className="text-center">
      <h1 className="text-xl font-semibold">Page not found</h1>
      <p className="mt-2 text-sm text-cream/70">
        The page you&apos;re looking for doesn&apos;t exist.
      </p>
      <Link
        to="/"
        className="mt-4 inline-block text-sm font-medium text-glow-600 hover:underline"
      >
        Go to your glows
      </Link>
    </Card>
  )
}
